import { Box, Card, List, ListItem, ListItemSecondaryAction, ListItemText, Typography } from '@material-ui/core';
import React, { Component } from 'react';
import Currency from '../../../commonModules/Currency';

class IncomeDetails extends Component {
    state = {  }
    render() {
        const { income } = this.props;
        return (
                <Card >
                    <Box p={1}>
                        <List>                                      
                            <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography variant="h6">Reste à pointer:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        color="secondary"
                                        primary={
                                            <Typography color="secondary" variant="subtitle1">
                                                <Currency suffix=" FCFA" value={income.income_total_available} />
                                            </Typography>
                                        }
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>  
                            <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography >Montant total:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        color="secondary"
                                        primary={
                                            <Typography variant="subtitle1">
                                                <Currency suffix=" FCFA" value={income.income_amount} />
                                            </Typography>
                                        }
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>                                                
                            <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography>Date encaissement:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        primary={new Date(income.income_date).toLocaleDateString("fr-FR")}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            
                            <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography>Banque:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText primary={income.income_bank} />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography>Poste:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText primary={income.income_post} />
                                </ListItemSecondaryAction>
                            </ListItem>
                            {/* <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography>Référence:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText primary={income.income_ref} />
                                </ListItemSecondaryAction>
                            </ListItem> */}
                            {/* <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography>Description:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText primary={income.income_desc} />
                                </ListItemSecondaryAction>
                            </ListItem> */}
                        </List>
                        <Box p={1}>
                            <Typography variant="caption">{income.income_desc}</Typography>
                        </Box>
                    </Box>
                </Card>
        );
    }
}

export default IncomeDetails;